/* eslint-env es6*/
/* eslint prefer-arrow-callback: ["error", { "allowNamedFunctions": true }]*/
import React from 'react';
import $ from 'jquery';
import { refDelete, refRestore } from './store';
import { selectRow } from '../../../../store/allaround.store';
import { connect } from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { ReactBootstrapTableRemotePagination } from
  '@/component/form/ReactBootstrapTableRemotePagination.jsx';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import { Glyphicon, Col, Grid, Modal } from 'react-bootstrap';
import {
  Button,
} from '../../../form/FormControls.jsx';
import {
  MainComponentBox,
  UrlWrappedLink,
  LinkLikeButton,
  TableOptions,
  paintColor,
  locationFallThroughInitial,
  navTo,
} from '../../../../util/util.jsx';
import { REF_NAME, REF_PATH, SUBTYPE_NAME, SUBTYPE_PATH, NAME } from './Const';
import { getProductListWrapper } from './ProductWrapper.js';
import AvailableSince, { VERSIONS } from '@/util/version';
import { Audit } from '@/component/blogic/deals/audit/Audit.jsx';
import RoleConfigFilter from '@/component/auth/RoleConfigFilter.jsx';
import trash from '../../../../../style/trash.png';
import audit from '../../../../../style/audit.png';
import pencil from '../../../../../style/pencil.png';
import { getTextFilter } from '@/component/form/ReactBootstrapTableTextFilter';

function mapRefPath(data, refPath, showHiddenProduct = false) {
  return data ? data
    .filter(x => (showHiddenProduct ? true : !x.get('hidden')))
    .map(x => x.set('refPath', refPath))
    .map(x => x.toJS())
    .toArray() : undefined;
}

const mapStateToProps = (refPath) => (state) => ({
  refs: state.getIn(['references', 'complex', refPath]),
  row: state.getIn(['allaround', 'productRow']),
  page: state.getIn(['allaround', 'productPage']),
});

const mapDispatchToProps = () => (dispatch) => ({
  selectRow: (id, page) => {
    selectRow(dispatch, REF_NAME, id, page);
  },
  refDeleteProduct: (id) => {
    refDelete(dispatch, REF_NAME, REF_PATH, id);
  },
  refDeleteProductType: (id, parentId) => {
    refDelete(dispatch, SUBTYPE_NAME, SUBTYPE_PATH, id, parentId);
  },
  refRestoreProduct: (id) => {
    refRestore(dispatch, REF_NAME, REF_PATH, id);
  },
  refRestoreProductType: (id) => {
    refRestore(dispatch, SUBTYPE_NAME, SUBTYPE_PATH, id);
  },
});

class List extends React.Component {
  constructor(props) {
    super(props);
    this.setRefPath(REF_PATH);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.yesButton = this.yesButton.bind(this);
    this.renderModificationButtonsProduct = this.renderModificationButtons.bind(this, false);
    this.renderModificationButtonsSubType = this.renderModificationButtons.bind(this, true);
    this.renderColorProduct = this.renderColor.bind(this, false);
    this.showHiddenProductToggle = this.showHiddenProductToggle.bind(this);
    this.showHiddenProductTypeToggle = this.showHiddenProductTypeToggle.bind(this);
    this.state = {
      selectedRow: props.row ? props.row : null,
      selectedRowName: '',
      pageId: 1,
      showModal: false,
      id: undefined,
      parentId: undefined,
      showHiddenProduct: false,
      showHiddenProductType: false,
    };
  }

  componentWillMount() {
    getProductListWrapper();
    locationFallThroughInitial(NAME, `/references/${REF_PATH}`);
    this.setNewRefs(this.props);
  }

  componentWillReceiveProps(props) {
    getProductListWrapper();
    this.setNewRefs(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.pageId !== this.state.pageId) {
      this.props.selectRow(nextState.selectedRow, nextState.pageId);
      return false;
    }
    return true;
  }

  setNewRefs(props,
    showHiddenProduct = this.state.showHiddenProduct,
    showHiddenProductType = this.state.showHiddenProductType) {
    if (props.refs) {
      const row = props.row;
      const page = props.page;
      if (props.refs && row !== undefined && row !== null) {
        const prod = props.refs.find(ref => ref.get('id') == row);
        this.setState({
          subtypes: this.filterSubtypes(prod, showHiddenProductType),
          selectedRow: row, pageId: page == undefined ? 1 : page, selectedRowName: prod.get('name'),
          mappedRefs: mapRefPath(props.refs, this.refPath, showHiddenProduct),
        });
      } else {
        this.setState({
          subtypes: [], selectedRow: row, pageId: page == undefined ? 1 : page,
          label: '', mappedRefs: mapRefPath(props.refs, this.refPath, showHiddenProduct),
        });
      }
    }
  }


  setRefPath(refPath) {
    this.refPath = refPath;
  }

  showHiddenProductToggle() {
    this.setState({
      showHiddenProduct: !this.state.showHiddenProduct,
      refs: this.setNewRefs(this.props,
        !this.state.showHiddenProduct, this.state.showHiddenProductType),
    });
  }

  showHiddenProductTypeToggle() {
    this.setState({
      showHiddenProductType: !this.state.showHiddenProductType,
      refs: this.setNewRefs(this.props,
        this.state.showHiddenProduct, !this.state.showHiddenProductType),
    });
  }

  filterSubtypes(prod, showHiddenProductType = this.state.showHiddenProductType) {
    if (prod) {
      return prod.get('productTypes')
        .filter(pr => {
          if (pr.get('name') == 'DEFAULTPRODUCTTTYPE') {
            return false;
          }
          return showHiddenProductType ? true : !pr.get('hidden');
        })
        .toJS();
    }
    return [];
  }

  openModal(id, parentId, label) {
    this.setState({ showModal: true, id, parentId, label });
  }

  closeModal() {
    this.setState({ showModal: false, id: undefined });
  }

  yesButton() {
    if (!this.state.parentId) {
      this.props.refDeleteProduct(this.state.id);
      this.props.selectRow(undefined, this.props.page);
      this.setState({
        showModal: false,
        id: undefined,
        selectedRow: undefined,
        parentId: undefined,
      });
    } else {
      this.props.refDeleteProductType(this.state.id, this.state.parentId);
      this.setState({ showModal: false, id: undefined });
    }
  }

  restore(id) {
    this.props.refRestoreProduct(id);
  }

  restoreSubtype(id) {
    this.props.refRestoreProductType(id);
  }

  renderModificationButtons(subtype, id, ref) {
    let label;
    if (ref && (ref.productId || ref.product)) {
      label = "product's subtype";
    } else {
      label = 'product and all its subtypes';
    }
    return (<div className={'reference-mod-column'}>
      {ref.hidden ?
        <RoleConfigFilter permissions={['references#2']}>
          <LinkLikeButton
            onClick={() => (subtype ? this.restoreSubtype(id) : this.restore(id))}
            id={`restore_${subtype ? 'type_' : ''}${id}`} title="Restore"
          >
            <Glyphicon glyph="repeat" />
          </LinkLikeButton>
        </RoleConfigFilter>
        :
        <RoleConfigFilter permissions={['references#3']}>
          <LinkLikeButton
            onClick={() => (this.openModal(id, ref.product ? ref.product : ref.productId, label))}
            id={`del_${ref.refPath}_${id}`}
          >
            <img className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'} />
          </LinkLikeButton>
        </RoleConfigFilter>
      }
      <RoleConfigFilter permissions={['references#2']}>
        <UrlWrappedLink url={`/references/${ref.refPath}/${id}`} id={`edit_${ref.refPath}_${id}`}>
          <img
            src={pencil} alt={'edit'} title={'edit'} className={'payments-table-small-icon'}
          />
        </UrlWrappedLink>
      </RoleConfigFilter>
    </div>);
  }

  renderColor(hideUncolored, id, ref) {
    if (hideUncolored && (!ref || !ref.color || ref.color == '#FFFFFF')) {
      return <div />;
    }
    const color = ref.color && ref.color != '#FFFFFF'
      ? ref.color
      : paintColor(ref.id);

    return (
      <div className="text-center">
        <div
          style={{
            backgroundColor: color,
            height: 40,
            width: 40,
            borderRadius: 40,
          }}
        >
        </div>
      </div>
    );
  }

  render() {
    const self = this;
    const options = {
      onRowClick(row) {
        self.setState({ selectedRow: row.id, selectedRowName: row.name });
        self.props.selectRow(row.id, self.state.pageId);
      },
      onPageChange(page) {
        if (page !== self.state.pageId) {
          self.setState({ pageId: page, subtypes: [], selectedRow: null, selectedRowName: '' });
        }
      },
      page: this.state.pageId,
      defaultSortName: 'name',
      defaultSortOrder: 'asc',
    };
    return this.state.mappedRefs ?
      <div className="dict">
        <MainComponentBox wide>

          <Modal bsSize="small" show={this.state.showModal} onHide={this.closeModal}>
            <Modal.Body>
              Are you sure you want to delete this {this.state.label}?
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="danger" onClick={this.yesButton} id="delete_yes">Yes</Button>
              <Button onClick={this.closeModal} id="delete_no">No</Button>
            </Modal.Footer>
          </Modal>
          <Grid>
            <Col
              md={6}
              id="productTable" style={{ marginRight: 40 }}
              className={'references-list'}
            >
              <ReactBootstrapTableRemotePagination
                id="productTable"
                data={this.state.mappedRefs}
                striped
                hover
                condensed
                bordered={false}
                pagination={this.state.mappedRefs.length > 100}
                options={$.extend(options, TableOptions)}
                selectRow={{
                  mode: 'radio', bgColor: '#e4eef5', clickToSelect: true, hideSelectColumn: true,
                  columnWidth: '0px', selected: [self.state.selectedRow],
                }}
              >
                <TableHeaderColumn
                  dataField="name"
                  dataSort
                  className={'references-name-header product-name-column-header'}
                  columnClassName={'references-name-row product-name-column'}
                  filter={{ type: 'CustomFilter',
                    getElement: getTextFilter,
                    customFilterParameters: { columnName: 'Type Of Product name' },
                  }}
                >
                  TYPE OF PRODUCT
                </TableHeaderColumn>
                <TableHeaderColumn
                  width="98px"
                  thStyle={{ width: '44px' }}
                  dataField="color"
                  dataFormat={this.renderColorProduct}
                  columnClassName={'payments-pre-last-columns product-color-column'}
                  className={
                    'payments-pre-last-columns-header product-color-column-header'
                  }
                >
                  COLOR
                </TableHeaderColumn>
                <TableHeaderColumn
                  width="112"
                  dataFormat={this.renderModificationButtonsProduct} searchable={false}
                  dataField="id"
                  isKey
                  className={'payments-last-columns-header product-edit-column-header'}
                  columnClassName={'payments-last-columns'}
                >
                  <div>
                    <AvailableSince version={VERSIONS.VasyaFinal}>
                      <RoleConfigFilter permissions={['audit']}>
                        <Audit
                          entityType="reference"
                          title="Product audit"
                          module="product"
                          entityId=""
                        >
                          <img src={audit} className={'audit-icon'} alt={'Audit'} />
                        </Audit>
                      </RoleConfigFilter>
                    </AvailableSince>
                    <RoleConfigFilter permissions={['references#2']}>
                      <Button
                        id="addProduct"
                        bsStyle="primary"
                        onClick={() => navTo(`/references/${this.refPath}/new`)}
                      >
                      Add
                      </Button>
                    </RoleConfigFilter>
                  </div>
                </TableHeaderColumn>
              </ReactBootstrapTableRemotePagination>
            </Col>
            {this.state.selectedRow == null ? '' :
              <Col
                md={5} id="productTypesTable" className={'references-list'}
                style={{ marginLeft: 30 }}
              >
                <BootstrapTable
                  data={this.state.subtypes.map(function ref(x) {
                    const obj = x;
                    obj.refPath = `${self.refPath}/${self.state.selectedRow}/sub`;
                    return obj;
                  })} id="productTypeTable"
                  striped hover condensed bordered={false} pagination={false}
                  options={$.extend({ defaultSortName: 'name', defaultSortOrder: 'asc' },
                    TableOptions)}
                >
                  <TableHeaderColumn
                    dataField="name"
                    dataSort
                    className={'payments-pre-last-columns-header references-name-header' +
                    ' product-name-column-header'}
                    columnClassName={'payments-pre-last-columns references-name-row' +
                    ' product-name-column'}
                    filter={{ type: 'CustomFilter',
                      getElement: getTextFilter,
                      customFilterParameters: { columnName: `${this.state.selectedRowName} name` },
                    }}
                  >
                    {`${this.state.selectedRowName}'s subtypes`}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width="112"
                    dataFormat={this.renderModificationButtonsSubType} searchable={false}
                    isKey
                    dataField="id"
                    className={'payments-last-columns-header product-edit-column-header'}
                    columnClassName={'payments-last-columns'}
                  >
                    <div>
                      <AvailableSince version={VERSIONS.VasyaFinal}>
                        <RoleConfigFilter permissions={['audit']}>
                          <Audit
                            entityType="reference"
                            title="Product type audit"
                            module={`producttype/${this.state.selectedRow}`}
                            entityId=""
                          >
                            <img src={audit} className={'audit-icon'} alt={'Audit'} />
                          </Audit>
                        </RoleConfigFilter>
                      </AvailableSince>
                      <RoleConfigFilter permissions={['references#2']}>
                        <Button
                          id="addProductType"
                          bsStyle="primary"
                          onClick={() =>
                            navTo(`/references/${this.refPath}/${this.state.selectedRow}/sub/new`)}
                        >
                          Add
                        </Button>
                      </RoleConfigFilter>
                    </div>
                  </TableHeaderColumn>
                </BootstrapTable>
              </Col>
            }
          </Grid>
        </MainComponentBox>
      </div>
      : <div></div>;
  }
}

List.propTypes = {
  row: React.PropTypes.number,
  selectRow: React.PropTypes.func,
  page: React.PropTypes.number,
  refDeleteProduct: React.PropTypes.func,
  refDeleteProductType: React.PropTypes.func,
  refRestoreProduct: React.PropTypes.func,
  refRestoreProductType: React.PropTypes.func,
};

export default connect(mapStateToProps(REF_PATH), mapDispatchToProps(REF_NAME, REF_PATH))(List);
